import { useEffect } from 'react';
import { useLocale } from '../../../context/NbLocalizationContext';
import { NbButton } from '../../../shared/components/button/Button';
import { DotsLoader } from '../../../shared/components/dots-loader/DotsLoader';
import { MobileAppBannerContent } from '../../../shared/components/mobile-app-banner/MobileAppBannerContent';
import { DeviceDetectionUtils } from '../../../shared/utils/deviceDetection';
import { getMobileAppStoreLink } from '../../../shared/utils/mobileAppLink';
import classes from './AppRedirectPage.module.scss';

export const AppRedirectPage = () => {
  const { translation } = useLocale();

  useEffect(() => {
    const createMeta = (media: string, content: string) => {
      const meta = document.createElement('meta');
      meta.name = 'theme-color';
      meta.media = media;
      meta.content = content;
      document.head.appendChild(meta);
      return meta;
    };

    const lightMeta = createMeta('(prefers-color-scheme: light)', '#e2e8f0');
    const darkMeta = createMeta('(prefers-color-scheme: dark)', '#122a46');

    return () => {
      document.head.removeChild(lightMeta);
      document.head.removeChild(darkMeta);
    };
  }, []);

  useEffect(() => {
    window.location.href = getMobileAppStoreLink();
  }, []);

  return (
    <div className={classes.wrapper}>
      <MobileAppBannerContent isFullScreen />
      <DotsLoader label={translation.mobileAppBanner.loaderText} />
      <NbButton
        className={classes.openAppButton}
        variant="contained"
        color="primary"
        onClick={() => {
          window.location.href = getMobileAppStoreLink();
        }}
      >
        {DeviceDetectionUtils.getMobilePlatform() === 'android'
          ? translation.mobileAppBanner.openErsteMarketGoAndroid
          : translation.mobileAppBanner.openErsteMarketGoIOS}
      </NbButton>
    </div>
  );
};
